module.exports = __webpack_public_path__ + "static/media/arrow-long-up.b162fa04.svg";